import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { store } from './store.js';
import Layout from '@/pages/layout/index.js';

import './css/help-20210312.css';
class Knowledge extends Component {
  render() {
    return (
      <Provider store={store}>
        <Layout></Layout>
      </Provider>
    );
  }
}

export default Knowledge;
